import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import MainCampaignForm from "./MainCampaignForm.jsx";
import CustomerCampaignForm from "./CustomerCampaignDatagrid.jsx";
export function CampaignDetailContent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const [searchParams] = useSearchParams();
  const [SubjectName, setSubjectName] = useState();
  const id = searchParams.get("id");
  const [isDisabled, setDisabled] = useState(false);
  useEffect(() => {
    //run when id Change value.
    if (id > 0) {
      setSubjectName("Edit Campaign Details");
    } else {
      setSubjectName("New Campaign");
    }
  }, [id]);
  const [statusName, setStatusName] = useState(""); // สำหรับรับค่า status_name

  // callback สำหรับรับค่าจาก child
  const handleDataFromChild = ({ status }) => {
    setStatusName(status);
  };
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid container spacing={2}>
          <br />
          <br />
          <br />
        </Grid>
        <Grid container spacing={2}>
          <label className="head">{SubjectName}</label>
          <span
            className={`status-button badge activity-detail badge-status-${statusName
              .toLowerCase()
              .replace(/\s/g, "-")}`}
          >
            {statusName}
          </span>
        </Grid>

        <MainCampaignForm CAMPAIGN_ID={id} onDataChange={handleDataFromChild} />

        {/* <CustomerCampaignForm campaign_id={id} /> */}
      </Grid>
    </Container>
  );
}
